<template>
  <span class="upload-status">
    {{ status }}
    <help-icon v-if="statusMessage" :content="statusMessage" />
  </span>
</template>

<script>
import filesize from 'filesize';
import Status from './Status.js';
import HelpIcon from '../Shared/HelpIcon';

export default {
  inject: ['lang'],
  components: {
    HelpIcon
  },
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  computed: {
    status() {
      switch (this.file.status) {
        case Status.QUEUED:
          return this.lang.get('files.status.queued');
        case Status.UPLOADING:
          return this.uploadStatus;
        case Status.PROCESSING:
          return this.lang.get('files.status.processing');
        case Status.FAILED:
          return this.lang.get('files.status.failed');
        default:
          return '';
      }
    },
    statusMessage() {
      return this.file.statusMessage
        ? this.lang.get('files.status.' + this.file.statusMessage)
        : '';
    },
    uploadStatus() {
      const size =
        !isNaN(this.file.size) && this.file.size > 0
          ? ' (' +
            filesize(this.file.loaded) +
            '/' +
            filesize(this.file.size) +
            ')'
          : '';

      return this.file.percent > 0
        ? this.file.percent + '%' + size
        : this.lang.get('files.status.uploading');
    }
  }
};
</script>
